'use es6';

import { environmentUrl, hubletApi } from 'hub-http/middlewares/core';
export const privateHubTeamApi = environmentUrl(hubletApi('private', 'hubteam'));
export const privateApi = environmentUrl(hubletApi('private', 'hubapi'));
export const toolsApi = environmentUrl(hubletApi('tools', 'hubteam'));